import { render, staticRenderFns } from "./RegInfo.vue?vue&type=template&id=dd4b1680&scoped=true"
import script from "./RegInfo.vue?vue&type=script&lang=js"
export * from "./RegInfo.vue?vue&type=script&lang=js"
import style0 from "./RegInfo.vue?vue&type=style&index=0&id=dd4b1680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4b1680",
  null
  
)

export default component.exports